var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.5C28 23.9688 27.7812 24.3438 27.5 24.6562V27.1875C27.7812 27.375 28 27.6875 28 28.0312C28 28.5625 27.5312 29 27 29H17C15.3125 29 14 27.6875 14 26V16C14 14.3438 15.3125 13 17 13H26.5C27.3125 13 28 13.6875 28 14.5V23.5ZM18.4688 17C18.2188 17 18 17.25 18 17.5C18 17.7812 18.2188 18 18.4688 18H24.5C24.75 18 25 17.7812 25 17.5C25 17.25 24.75 17 24.4688 17H18.4688ZM18.4688 19C18.2188 19 18 19.25 18 19.5C18 19.7812 18.2188 20 18.4688 20H24.5C24.75 20 25 19.7812 25 19.5C25 19.25 24.75 19 24.4688 19H18.4688ZM26 27V25H17C16.4375 25 16 25.4688 16 26C16 26.5625 16.4375 27 17 27H26Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledBook);
export default __webpack_public_path__ + "static/media/filledBook.e9fc9e60836e5dd71d44d9e8c98b8745.svg";
export { ForwardRef as ReactComponent };